<template>
    <div class="popUpdateStatus_mask">
        <el-card class="box-card popUpdateStatus">
            <div slot="header" class="clearfix" style="text-align:center;">
                <span>编号</span>
                <span style="color:red">{{theId}}</span>
            </div>
            <div class="content">
                <p>
                    <span style="font-weight: 600;font-size: 16px;color: #444;margin-right: 10px;">原状态</span>
                    <span style="width: 217px;display: inline-block;text-align: left;">{{theStatus==0?'待发布':(theStatus==1?'已发布':(theStatus==2?'删除':'暂停'))}}</span>
                </p>
                <p>
                    <span style="font-weight: 600;font-size: 16px;color: #444;margin-right: 10px;">新状态</span>
                    <el-select v-model="myTheStatus" placeholder="">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </p>
            </div>
            <div class="footer" style="margin-top:35px;">
                <el-button type="danger" style="width:100px;margin-right:25px;" @click="boxClose">取消</el-button>
                <el-button type="success" style="width:100px;" @click="commit">确定</el-button>
            </div>
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
        </el-card>
    </div>
</template>

<script>
import $axios from '@/https/config'

export default {
  props: ['theId', 'theStatus', 'theZippath'],
  data () {
    return {
      options: [
        {
          value: 0,
          label: '待发布'
        },
        {
          value: 1,
          label: '已发布'
        },
        {
          value: 2,
          label: '删除'
        },
        {
          value: 3,
          label: '暂停'
        }
      ],
      myTheStatus: this.theStatus
    }
  },
  methods: {
    boxClose () {
      this.$emit('closeUpdateStatus', false)
    },
    commit () {
      var that = this
      var params = {
        id: that.theId,
        status: that.myTheStatus,
        zippath: that.theZippath
      }
      $axios.post('/manager/updateStatus', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          that.$message({
            type: 'success',
            message: '更新状态成功!'
          })
        } else {
        }
      }, function () {})
    }
  }
}
</script>

<style lang="scss">
  .popUpdateStatus_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
  
    .popUpdateStatus {
      min-height: 230px;
      width: 400px;
      top: 30%;
      left: 40%;
      z-index: 101;
      position: fixed;
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/versionMgr/popUpdateStatus.vue